export default "__VITE_ASSET__BGU_J5YH__"